import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('WebReputationKeywords');
export const actions = helper.createActions('WebReputationKeywords', actionTypes);